'use strict';

module.exports = require('form-data');
